import { useAuthStore } from '@/store/auth';

/**
 * Single source of truth for the masterclass A/B upgrade experiment on the client.
 * Reads the arm off the authenticated user and exposes a version-tagged event tracker.
 */
export const useExperiment = () => {
  const authStore = useAuthStore();
  const { sendEventToBackend } = useTracking();

  const variant = computed<'A' | 'B' | null>(() => authStore.user?.masterclassExperimentVariant ?? null);
  const isA = computed(() => variant.value === 'A');
  const isB = computed(() => variant.value === 'B');
  const inExperiment = computed(() => variant.value !== null);

  // Attaches the experiment dimension + the identity join key. Country/campaign/
  // source/click-IDs/UTM ride along automatically via the tracking pipeline.
  const trackExperimentEvent = (name: string, extra: Record<string, unknown> = {}) =>
    sendEventToBackend(name, { version: variant.value, crm_user_id: authStore.user?.id, ...extra });

  return { variant, isA, isB, inExperiment, trackExperimentEvent };
};
